import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import NiceGuyAssessment from "./pages/NiceGuyAssessment";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import SubmitTestimonial from "./pages/SubmitTestimonial";
import SevenSigns from "./pages/SevenSigns";
import About from "./pages/About";
import Journal from "./pages/Journal";
import NiceGuy from "./pages/NiceGuy";
import Connect from "./pages/Connect";
import Unsubscribe from "./pages/Unsubscribe";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/nice-guy" element={<NiceGuy />} />
          <Route path="/connect" element={<Connect />} />
          <Route path="/nice-guy-assessment" element={<NiceGuyAssessment />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Navigate to="/connect" replace />} />
          <Route path="/content" element={<Navigate to="/journal" replace />} />
          <Route path="/brotherhood" element={<Navigate to="/" replace />} />
          <Route path="/resources" element={<Navigate to="/" replace />} />
          <Route path="/testimonials/submit" element={<SubmitTestimonial />} />
          <Route path="/7-signs" element={<SevenSigns />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
